export const STORAGE_KEY = 'map-zoom-level';
export const MAP_ZOOM_LEVEL = 6;
export const MAP_ZOOM_LEVEL_MOBILE = 5;

export const STORAGE_KEY_THEME = 'map-theme';
export const MAP_THEME = 'soil_zone_sld';

export const STORAGE_KEY_BASEMAP = 'map-basemap';
export const MAP_BASEMAP = 'Aerial';

export const STORAGE_KEY_LAYER = 'map-layer';
export const MAP_LAYER = [
  'polygonsLayer',
  'labelsLayer',
  'ruralMunicipalities',
  'township',
  'sectionLayer',
  'urbanCenters',
];

export const STORAGE_KEY_POLYGON_OPACITY = 'map-polygon-opacity';
export const MAP_POLYGON_OPACITY = 100;

export const STORAGE_KEY_SEARCH_TYPE = 'search-type';
export const DEFAULT_SEARCH_TYPE = 'lld';

export const STORAGE_KEY_QUERY_ATTRIBUTE = 'query-selected-attribute';
export const STORAGE_KEY_QUERY_VALUE = 'query-selected-value';



export const STORAGE_KEY_QUERY_STATE = 'query-state';

// LLD Search storage keys
export const STORAGE_KEY_LLD_SECTION = 'lld-section';
export const STORAGE_KEY_LLD_TOWNSHIP = 'lld-township';
export const STORAGE_KEY_LLD_RANGE = 'lld-range';
export const STORAGE_KEY_LLD_MERIDIAN = 'lld-meridian';

// Lat-Long Search storage keys
export const STORAGE_KEY_LATITUDE = 'lat-long-latitude';
export const STORAGE_KEY_LONGITUDE = 'lat-long-longitude';

// UTM Search storage keys
export const STORAGE_KEY_UTM_ZONE = 'utm-zone';
export const STORAGE_KEY_UTM_EASTING = 'utm-easting';
export const STORAGE_KEY_UTM_NORTHING = 'utm-northing';

// RM Search storage keys
export const STORAGE_KEY_RM_SELECTED = 'rm-selected';
